import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { getCitiesByCountryId } from "../../api";
import "./CityPage.css";

const CityList = ({ t }) => {
  const { countryId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Country name from previous page
  const countryName = location.state?.countryName || "";

  useEffect(() => {
    if (!countryId) return;

    setLoading(true);
    getCitiesByCountryId(countryId)
      .then((data) => {
        setCities(data || []);
        setError("");
      })
      .catch(() => setError("Failed to fetch cities"))
      .finally(() => setLoading(false));
  }, [countryId]);

 // Example for cities.js
const handleCityClick = (city) => {
  navigate(`/cityplaces/${city.CityID}`);

};

  if (!countryId) return null;

  return (
    <main className="container page city-page">
      {/* Title */}
      {countryName && (
        <h2 className="country-title">
          {countryName}
        </h2>
      )}

      {/* Loading / Errors */}
      {loading && <div className="muted">Loading cities...</div>}
      {error && <div className="error">{error}</div>}

      {/* City List Grid */}
      <div className="city-list">
        {cities.map((city) => (
          <div
            key={city.cityID}
            className="city-card"
            onClick={() => handleCityClick(city)}
          >
            {/* City image fallback */}
            {city.Image ? (
              <img
                src={city.Image}
                alt={city.CityName}
                className="city-thumb"
              />
            ) : (
              <div className="city-thumb">
                {city.CityName?.charAt(0).toUpperCase() || "?"}
              </div>
            )}

            <div className="city-name">{city.CityName}</div>

            <div className="muted">
              {city.Description
                ? `${city.Description} places`
                : "No places listed"}
            </div>
          </div>
        ))}
      </div>

      {/* Back Button */}
      <div className="back-countries-bar">
        <button
          className="back-to-countries-btn"
          onClick={() => navigate("/countries")}
        >
          ← Back to Countries
        </button>
      </div>
    </main>
  );
};

CityList.propTypes = {
  t: PropTypes.func,
};

export default CityList;
